import { render, staticRenderFns } from "./Problems.vue?vue&type=template&id=ff8af3aa&scoped=true&"
import script from "./Problems.vue?vue&type=script&lang=js&"
export * from "./Problems.vue?vue&type=script&lang=js&"
import style0 from "./Problems.vue?vue&type=style&index=0&id=ff8af3aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8af3aa",
  null
  
)

export default component.exports